import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["to", "children", "origin"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import { Link } from 'react-router-dom';
import { useAppNameContext } from 'hooks/useAppNameContext';
import Button from 'components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
export function AdminOrHubButtonLink(props) {
  var to = props.to,
    children = props.children,
    _props$origin = props.origin,
    origin = _props$origin === void 0 ? 'admin' : _props$origin,
    otherProps = _objectWithoutProperties(props, _excluded);
  var appNameContext = useAppNameContext();
  var nonOriginPath = origin === 'admin' ? "/admin".concat(to) : to.toString();
  if (appNameContext !== origin) {
    return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
      target: "_blank"
    }, otherProps), {}, {
      as: "a",
      href: nonOriginPath,
      children: children
    }));
  } else {
    return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, otherProps), {}, {
      as: Link,
      to: to,
      children: children
    }));
  }
}
export default AdminOrHubButtonLink;